<div style="max-width: 843px">
    <div
        class="card mb-3"
        [class.card-modified]="businessCreation"
        [class.main-card]="!businessCreation"
    >
        <div class="card-body">
            <h5 class="card-title" *ngIf="!businessCreation">
                {{ (!create ? 'location-form.editTitleLabel' : 'location-form.titleLabel') | translate }}
            </h5>

            <form [formGroup]="locationForm" (ngSubmit)="onSubmit()">
                <div class="d-flex flex-column flex-md-row justify-content-start align-items-center align-items-md-start">
                    <div class="mt-md-2 mb-3 mb-md-0">
                        <div class="border rounded-1 overflow-hidden" style="height: 301px">
                            <google-map
                                width="300px"
                                height="300px"
                                [center]="mapLocation"
                                [scrollwheel]="true"
                                [zoom]="13"
                                [options]="{ controlSize: 30 }"
                                [usePanning]="true"
                            >
                                <map-marker
                                    [position]="mapLocation"
                                    [options]="markerOptions"
                                />
                            </google-map>
                        </div>

                        <label>{{ mssgMap }}</label>
                    </div>

                    <div class="ms-md-4">
                        <div class="form-group">
                            <label for="name" class="form-label form-label-required">
                                {{ 'location-form.nameLabel' | translate }}
                            </label>

                            <input 
                                formControlName="name" 
                                name="name" id="name" 
                                placeholder="{{ 'location-form.namePlaceholder' | translate }}" 
                                type="text"
                                class="form-control form-control-lg"
                                (input)="create ? enterShortName($event) : ''"
                                [class.invalid-field]="locationForm.get('name').dirty && locationForm.get('name').invalid"
                            />
                        </div>

                        <div class="form-group">
                            <label for="address" class="form-label form-label-required">
                                {{ 'location-form.addressLabel' | translate }}
                            </label>

                            <label class="form-label form-label-sublabel" style="font-size:12px">
                                {{ 'location-form.addressSublabel' | translate }}
                            </label>

                            <input ngx-google-places-autocomplete
                                class="form-input form-control form-control-lg"
                                formControlName="address" 
                                placeholder="{{ 'location-form.addressPlaceholder' | translate }}"
                                #placesRef="ngx-places" 
                                (onAddressChange)="addGooglePlaceId($event)"
                            />
                        </div>

                        <div class="row gx-3">
                            <div class="col-6 form-group">
                                <label for="phoneNumber" class="form-label form-label-required">
                                    {{ 'location-form.phoneNumberLabel' | translate }}
                                </label>

                                <ngx-intl-tel-input
                                    [preferredCountries]="preferredCountries"
                                    [enableAutoCountrySelect]="false"
                                    [searchCountryFlag]="true"
                                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                    [selectFirstCountry]="true" 
                                    [selectedCountryISO]="selectedCountry"
                                    [maxLength]="15" 
                                    [phoneValidation]="true" 
                                    [separateDialCode]="true"
                                    name="phoneNumber"
                                    formControlName="phoneNumber"
                                    cssClass="form-control form-control-lg"
                                />

                                <div
                                    *ngIf="locationForm.value.phoneNumber && locationForm.controls['phoneNumber'].invalid"
                                    class="lbl-phone-invalid"
                                >
                                    Phone number is not valid
                                </div>
                            </div>

                            <div class="col-6 form-group">
                                <label for="zipCode" class="form-label form-label-required">
                                    {{ 'location-form.zipCodeLabel' | translate }}
                                </label>

                                <input 
                                    formControlName="zipCode" 
                                    name="zipCode" id="zipCode" 
                                    placeholder="{{ 'location-form.zipCodePlaceholder' | translate }}"
                                    type="text" 
                                    class="form-control form-control-lg"
                                    [ngClass]="locationForm.get('zipCode').dirty && locationForm.get('zipCode').invalid ? 'invalid-field' : ''"
                                />
                            </div>
                        </div>

                        <div
                            *ngxPermissionsOnly="['addShortNameToLocation']"
                            class="position-relative form-group"
                        >
                            <label for="shortName" class="form-label">
                                {{ 'location-form.shortNameLabel' | translate }}
                            </label>

                            <input 
                                formControlName="shortName" 
                                name="shortName" id="shortName" 
                                placeholder="{{ 'location-form.shortNamePlaceholder' | translate }}"
                                type="text" 
                                class="form-control form-control-lg"
                                (input)="validateShort($event)"
                                [ngClass]="(locationForm.get('shortName').invalid || locationForm.get('shortNameExist').invalid) || existShortName ? 'invalid-field' : ''"
                            />

                            <label
                                *ngIf="existShortName"
                                class="form-label form-label-sublabel"
                                style="color: #dc4141; margin-top: 10px;"
                            >
                                *This shortname is not available, please choose a new one.
                            </label>

                            <label
                                *ngIf="locationForm.get('shortName').invalid"
                                class="form-label form-label-sublabel"
                                style="color: #dc4141; margin-top: 10px;"
                            >
                                *Shortname contains invalid characters. Only alphanumeric characters are allowed.
                            </label>
                        </div>

                        <div
                            *ngxPermissionsOnly="['enableOpenaiIntegration']"
                            class="d-flex align-items-center row gx-3"
                        >
                            <div class="col-6 form-group mt-4">
                                <p-checkbox
                                    class="me-3 mb-2" 
                                    [(ngModel)]="isEnableOpenaiIntegration" 
                                    label="OpenAI Integration"
                                    [binary]="true" 
                                    [ngModelOptions]="{ standalone: true }"
                                    (onChange)="enableOpenaiIntegration(!!$event.checked)">
                                </p-checkbox>
                            </div>

                            <div class="col-6 form-group" *ngxPermissionsOnly="['openAIReplyLimitRequest']">
                                <label for="shortName" class="form-label">
                                    {{ 'location-form.openAIReplyLimitRequest' | translate }}
                                </label>

                                <input 
                                    formControlName="openAIReplyLimitRequest" 
                                    name="openAIReplyLimitRequest" 
                                    id="openAIReplyLimitRequest"
                                    type="number" 
                                    class="form-control"
                                    [disableControl]="!isEnableOpenaiIntegration"
                                     style="width: 40%;"
                                    [ngClass]="locationForm.get('openAIReplyLimitRequest').dirty && locationForm.get('openAIReplyLimitRequest').invalid ? 'invalid-field' : ''"
                                />
    
                            </div>
                        </div>

                        <div
                            class="d-flex align-items-center row gx-3"
                        >
                            <div class="form-group mt-4 col-6" *ngxPermissionsOnly="['enebleMulticampaignLocation']">
                                <p-checkbox
                                    class="me-3 mb-2"
                                    [(ngModel)]="isMultiCampaignEnabled"
                                    label="{{ 'location-form.multicampaign' | translate }}"
                                    [binary]="true"
                                    [ngModelOptions]="{ standalone: true }"
                                    (onChange)="enableMulticampaign(!!$event.checked)"
                                />
                            </div>
                            <div class="form-group mt-4 col-6" *ngxPermissionsOnly="['enableSentimentCheckLocation']">
                                <p-checkbox
                                    class="me-3 mb-2"
                                    [(ngModel)]="isSentimentCheckEnabled"
                                    label="{{ 'location-form.enabledSentimentCheck' | translate }}"
                                    [binary]="true"
                                    [ngModelOptions]="{ standalone: true }"
                                    (onChange)="enableSentimentCheck(!!$event.checked)"
                                />
                            </div>
                        </div>
                        <div
                            class="d-flex align-items-center row gx-3"
                        >
                        <div class="form-group mt-4 col-6" *ngxPermissionsOnly="['enableZapierLocation']">
                            <p-checkbox
                                class="me-3 mb-2"
                                [(ngModel)]="isZapierEnabled"
                                label="{{ 'location-form.enabledZapier' | translate }}"
                                [binary]="true"
                                [ngModelOptions]="{ standalone: true }"
                                (onChange)="enableZapierCheck(!!$event.checked)"
                            />
                        </div>
                    </div>

                        <div *ngIf="businessCreation">
                            <button
                                class="mt-2 btn btn-primary"
                                type="submit"
                                [disabled]="!locationForm.valid"
                            >
                                Create
                            </button>

                            <button
                                *ngIf="showCancelButton"
                                class="mt-2 ms-2 btn btn-outline-secondary"
                                (click)="cancel.emit()"
                            >
                                {{ 'location-form.cancelButton' | translate }}
                            </button>
                        </div>

                        <div *ngIf="!businessCreation">
                            <button
                                class="mt-2 btn btn-primary"
                                type="submit"
                                [disabled]="!locationForm.valid"
                            >
                                {{ (!create
                                    ? 'location-form.editLocationButton'
                                    : 'location-form.createLocationButton'
                                    ) | translate
                                }}
                            </button>

                            <button
                                *ngIf="showCancelButton"
                                class="mt-2 ms-2 btn btn-outline-secondary"
                                (click)="cancel.emit()"
                            >
                                {{ 'location-form.cancelButton' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
